import {
  call,
  put,
  takeLatest,
  takeEvery
} from "redux-saga/effects";
import { downloadFile } from "utils/api";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , fillDictionary
  , subKeySaga
} from "shared-utility/store/utils/helpers";

export const GET_COMPANIES = generateDefaultActions("GET_COMPANIES");
export const GET_COMPANY_BY_ID = generateDefaultActions("GET_COMPANY_BY_ID");
export const GET_ALL_COMPANIES = generateDefaultActions("GET_ALL_COMPANIES");
export const GET_COMPANY_FOR_USER = generateDefaultActions("GET_COMPANY_FOR_USER");
export const GET_COMPANIES_BY_TYPE = generateDefaultActions("GET_COMPANIES_BY_TYPE");
export const GET_COMPANIES_BY_TYPE_ID = generateDefaultActions("GET_COMPANIES_BY_TYPE_ID");
export const GET_COMPANY_LEVEL_BY_ID = generateDefaultActions("GET_COMPANY_LEVEL_BY_ID");
export const GET_COMPANY_TYPE_BY_ID = generateDefaultActions("GET_COMPANY_TYPE_BY_ID");
export const GET_COMPANY = generateDefaultActions("GET_COMPANY");
export const GET_COMPANY_TYPES = generateDefaultActions("GET_COMPANY_TYPES");
export const CREATE_COMPANY = generateDefaultActions("CREATE_COMPANY");
export const UPDATE_COMPANY = generateDefaultActions("UPDATE_COMPANY");
export const DOWNLOAD_COMPANIES = generateDefaultActions("DOWNLOAD_COMPANIES");
export const CHANGE_COMPANY_FOR_CONTACT = generateDefaultActions("CHANGE_COMPANY_FOR_CONTACT");
export const CHANGE_COMPANY_FOR_CONTACT_BANNER = generateDefaultActions("CHANGE_COMPANY_FOR_CONTACT_BANNER");
export const GET_COMPANY_LEVELS = generateDefaultActions("GET_COMPANY_LEVELS");
export const GET_SUP_CALC_INFO = generateDefaultActions("GET_SUP_CALC_INFO");
export const SAVE_SUP_CALC_SETTINGS = generateDefaultActions("SAVE_SUP_CALC_SETTINGS");
export const GET_TRACKABLE_PROCESS_INFO = generateDefaultActions("GET_TRACKABLE_PROCESS_INFO");
export const MARK_RUNNING_PROCESSES_AS_STOPPED = generateDefaultActions("MARK_RUNNING_PROCESSES_AS_STOPPED");
export const CREATE_COMPANY_REPORTING_EMAIL = generateDefaultActions("CREATE_COMPANY_REPORTING_EMAIL");

export const SHOULD_REFRESH_COMPANY = "SHOULD_REFRESH_COMPANY";
export const AMELIORATE_COMPANY_ERROR = "AMELIORATE_COMPANY_ERROR";

// constants
export const markRunningProcessesAsStopped = payload => makePayload(MARK_RUNNING_PROCESSES_AS_STOPPED.value, payload);
export const getTrackableProcessInfo = payload => makePayload(GET_TRACKABLE_PROCESS_INFO.value, payload);
export const getSupCalcInfo = payload => makePayload(GET_SUP_CALC_INFO.value, payload);
export const saveSupplementalCalcSettings = payload => makePayload(SAVE_SUP_CALC_SETTINGS.value, payload);
export const LENDER = "Lender";
export const BROKER = "Broker";
export const LENDER_COUNSEL = "Lender's Counsel";

// Action creators
export const getCompanies = payload => makePayload(GET_COMPANIES.value, payload);
export const getAllCompanies = payload => makePayload(GET_ALL_COMPANIES.value, payload);
export const getCompanyForUser = payload => makePayload(GET_COMPANY_FOR_USER.value, payload);
export const getCompaniesByType = payload => makePayload(GET_COMPANIES_BY_TYPE.value, payload);
export const getCompaniesByTypeId = payload => makePayload(GET_COMPANIES_BY_TYPE_ID.value, payload);
export const getCompanyLevelById = payload => makePayload(GET_COMPANY_LEVEL_BY_ID.value, payload);
export const getCompanyTypeById = payload => makePayload(GET_COMPANY_TYPE_BY_ID.value, payload);

export const getLenders = () => getCompaniesByType({ typeName: LENDER });
export const getBrokers = () => getCompaniesByType({ typeName: BROKER });
export const getLenderCounsels = () => getCompaniesByType({ typeName: LENDER_COUNSEL });
export const getCompany = payload => makePayload(GET_COMPANY.value, payload);

export const ameliorateCompanyError = () => makePayload(AMELIORATE_COMPANY_ERROR);
export const getCompanyTypes = payload => makePayload(GET_COMPANY_TYPES.value, payload);
export const createCompany = payload => makePayload(CREATE_COMPANY.value, payload);
export const getCompanyLevels = payload => makePayload(GET_COMPANY_LEVELS.value, payload);
export const updateCompany = payload => makePayload(UPDATE_COMPANY.value, payload);
export const changeCompanyForContact = payload => makePayload(CHANGE_COMPANY_FOR_CONTACT.value, payload);
export const changeCompanyForContactBanner = payload => makePayload(CHANGE_COMPANY_FOR_CONTACT_BANNER.value, payload);
export const setShouldRefresh = payload => makePayload(SHOULD_REFRESH_COMPANY, payload);
export const downloadCompanies = payload => makePayload(DOWNLOAD_COMPANIES.value, payload);
export const createCompanyReportingEmail = payload => makePayload(CREATE_COMPANY_REPORTING_EMAIL.value, payload);

// Saga
export function* getCompanyForUserSaga() {
  const url = "/getCompanyForUser";
  yield requestSaga(GET_COMPANY_FOR_USER, url);
}

export function* getCompanyLevelByIdSaga(payload) {
  const url = `/companyTierById?id=${payload.id}`;
  yield requestSaga(GET_COMPANY_LEVEL_BY_ID, url);
}

export function* getCompanyTypeByIdSaga(payload) {
  const url = `/companyTypeById/${payload.companyId}`;
  yield requestSaga(GET_COMPANY_TYPE_BY_ID, url);
}

function* markRunningProcessesAsStoppedSaga(payload) {
  const url = "/markRunningProcessesAsStopped";
  yield requestSaga(MARK_RUNNING_PROCESSES_AS_STOPPED, url, "POST", payload);
}

function* getTrackableProcessInfoSaga(payload) {
  const url = "/getTrackableProcessInfo";
  yield requestSaga(GET_TRACKABLE_PROCESS_INFO, url, "POST", payload);
}

function* saveSupplementalCalcSettingsSaga(payload) {
  const url = "/saveSupplementalCalcSettings";
  yield requestSaga(SAVE_SUP_CALC_SETTINGS, url, "POST", payload);
}

function* getSupCalcInfoSaga(payload) {
  const url = "/supplementalCalcSettings";
  yield requestSaga(GET_SUP_CALC_INFO, url, "POST", payload);
}

function* getPaginatedCompaniesSaga(payload) {
  let url = "/companies";
  const {
    page,
    limit,
    searchText
  } = payload;
  // Add pagination params
  if (page >= 0 && limit >= 0) {
    url = `${url}?page=${page + 1}&limit=${limit}&searchText=${searchText || ""}`;
  }
  yield requestSaga(GET_COMPANIES, url);
}

function* getCompaniesByTypeSaga(payload) {
  const { typeName } = payload;
  const url = `/companiesByType?typeName=${typeName}`;

  yield requestSaga(GET_COMPANIES_BY_TYPE, url);
}

function* getCompaniesByTypeIdSaga(payload) {
  const {
    companyTypeId,
    subKey
  } = payload;
  const url = `/companiesByTypeId/${companyTypeId}`;
  const requestSaga = subKeySaga(subKey);
  yield requestSaga(GET_COMPANIES_BY_TYPE_ID, url);
}

export function* getCompanySaga(payload) {
  const url = `/companies/${payload.id}`;
  yield requestSaga(GET_COMPANY, url);
}

function* getAllCompaniesSaga(payload) {
  const url = `/allCompanies?activeOnly=${payload.activeOnly}`;
  yield requestSaga(GET_ALL_COMPANIES, url);
}

function* getCompanyTypesSaga(payload) {
  let url = "/companyTypes";
  if (payload.id) {
    url = `${url}/${payload.id}`;
  }
  yield requestSaga(GET_COMPANY_TYPES, url);
}

function* createCompanySaga(payload) {
  yield requestSaga(CREATE_COMPANY, "/companies", "POST", payload);
  yield put({
    type: SHOULD_REFRESH_COMPANY,
    payload: {
      shouldRefresh: true
    }
  });
}

function* updateCompanySaga(payloadObj) {
  const {
    payload,
    companyId
  } = payloadObj;
  yield requestSaga(UPDATE_COMPANY, `/companies/${companyId}`, "PUT", payload);
  yield put({
    type: SHOULD_REFRESH_COMPANY,
    payload: {
      shouldRefresh: true
    }
  });
}

function* changeCompanyForContactSaga(payload) {
  const url = "/contact/changeCompany";
  yield requestSaga(CHANGE_COMPANY_FOR_CONTACT, url, "POST", payload);
}

function* changeCompanyForContactBannerSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = "/contact/changeCompany";
  yield requestSaga(CHANGE_COMPANY_FOR_CONTACT_BANNER, url, "POST", payload);
  if (callback) {
    callback();
  }
}

function* downloadCompaniesSaga(payload) {
  try {
    yield call(downloadFile, "companiesdownload", "GET");
  } catch (error) {
    yield put(DOWNLOAD_COMPANIES.createFailure(error));
  }
}

function* getCompanyLevelsSaga(payload) {
  const url = "/companyLevels";
  yield requestSaga(GET_COMPANY_LEVELS, url, "GET");
}

export const UPSERT_COMPANY_IDENTIFIER = generateDefaultActions("UPSERT_COMPANY_IDENTIFIER");
export const upsertCompanyIdentifier = payload => makePayload(UPSERT_COMPANY_IDENTIFIER.value, payload);
function* upsertCompanyIdentifierSaga(payload) {
  const callback = handleCallback(payload);
  const { companyId, newIdentifier } = payload;
  const url = "/companyIdentifier";
  yield requestSaga(UPSERT_COMPANY_IDENTIFIER, url, "POST", { id: companyId, identifier: newIdentifier });
  yield callback();
}

export const DELETE_COMPANY_IDENTIFIER = generateDefaultActions("DELETE_COMPANY_IDENTIFIER");
export const deleteCompanyIdentifier = payload => makePayload(DELETE_COMPANY_IDENTIFIER.value, payload);
function* deleteCompanyIdentifierSaga(payload) {
  const callback = handleCallback(payload);
  const { id, companyId } = payload;
  const url = "/companyIdentifier";
  yield requestSaga(DELETE_COMPANY_IDENTIFIER, url, "DELETE", { id, companyId });
  yield callback();
}

export const GET_SPONSOR_COMPANIES = generateDefaultActions("GET_SPONSOR_COMPANIES");
export const getSponsorCompanies = payload => makePayload(GET_SPONSOR_COMPANIES.value, payload);
function* getSponsorCompaniesSaga() {
  const url = "/authorizedSponsorCompanyList";
  yield requestSaga(GET_SPONSOR_COMPANIES, url, "GET");
}

export function* createCompanyReportingEmailSaga(payload) {
  const url = "/calculations/createCompanyReportingEmail";
  yield requestSaga(CREATE_COMPANY_REPORTING_EMAIL, url, "POST", payload, null, null, true);
}

const initialState = {
  error: "",
  companiesByTypeId: {},
  shouldRefresh: false,
  shouldRefreshBanner: false,
  companyLevels: [],
  companyTypes: [],
  companyTypesById: [],
  supCalcSettings: {},
  trackableProcessInfo: {},
  sponsorCompanies: [],
  companyIdentifiers: []
};

export default function companiesReducer(state = initialState, action) {
  const {
    type,
    subKey,
    payload
  } = action;
  const newState = { ...state };
  switch (type) {
    case GET_TRACKABLE_PROCESS_INFO:
      return defaultReturn(state, {}, "trackableProcessInfo");
    case GET_TRACKABLE_PROCESS_INFO.success:
      return defaultReturn(state, payload.result, "trackableProcessInfo");
    case SAVE_SUP_CALC_SETTINGS.success:
      ToastSuccess("Save Success");

      return state;
    case SAVE_SUP_CALC_SETTINGS.failure:
      ToastError("Error Saving");

      return state;
    case GET_SUP_CALC_INFO.value:
      return defaultReturn(state, {}, "supCalcSettings");
    case GET_SUP_CALC_INFO.success:
      return defaultReturn(state, payload.results, "supCalcSettings");
    case UPSERT_COMPANY_IDENTIFIER.success:
      return defaultReturn(state, payload.results, "company");
    case DELETE_COMPANY_IDENTIFIER.success:
      return defaultReturn(state, payload.results, "company");
    case GET_COMPANY_LEVELS.success:
      return defaultReturn(state, payload.companyLevels, "companyLevels");
    case GET_COMPANIES.success:
      return defaultReturn(state, payload, "companiesPage");
    case GET_ALL_COMPANIES.success:
      return defaultReturn(state, payload, "allCompanies");
    case GET_COMPANIES_BY_TYPE.success:
      // eslint-disable-next-line no-case-declarations
      const key = Object.keys(payload)[0];

      return fillDictionary(state, payload[key], "companiesByType", key);
    case GET_COMPANIES_BY_TYPE_ID.success:
      return fillDictionary(state, payload.data, "companiesByTypeId", subKey);
    case GET_COMPANY.success:
      return defaultReturn(state, payload, "company");
    case GET_COMPANY_TYPES.success:
      return defaultReturn(state, payload, "companyTypes");
    case GET_COMPANY_TYPE_BY_ID.success:
      return defaultReturn(state, payload.companyTypes, "companyTypesById");
    case CREATE_COMPANY.success:
      return defaultReturn(state, payload, "company");
    case CHANGE_COMPANY_FOR_CONTACT.success:
      return defaultReturn(state, payload, "shouldRefresh");
    case CHANGE_COMPANY_FOR_CONTACT_BANNER.success:
      return defaultReturn(state, payload, "shouldRefreshBanner");
    case GET_COMPANY_FOR_USER.success:
      return defaultReturn(state, payload.data, "sponsorCompanies");
    case GET_SPONSOR_COMPANIES.success:
      return defaultReturn(state, payload.data, "companySponsorCompanies");
    case CREATE_COMPANY.failure:
      return {
        ...state,
        companyError: {
          hasError: true
        }
      };
    case AMELIORATE_COMPANY_ERROR:
      return {
        ...state,
        companyError: {
          hasError: false
        }
      };
    case UPDATE_COMPANY.success:
      ToastSuccess("Save successful");

      return defaultReturn(state, payload, "company");
    case SHOULD_REFRESH_COMPANY:
      return {
        ...state,
        shouldRefresh: payload
      };
    case DOWNLOAD_COMPANIES:
      return defaultReturn(state, payload, "");
    case CREATE_COMPANY_REPORTING_EMAIL.value:
      return defaultReturn(state);
    default:
      return state;
  }
}

export function* companiesSaga() {
  yield takeLatest(GET_COMPANIES.value, getPaginatedCompaniesSaga);
  yield takeEvery(GET_COMPANIES_BY_TYPE.value, getCompaniesByTypeSaga);
  yield takeEvery(GET_COMPANY_FOR_USER.value, getCompanyForUserSaga);
  yield takeEvery(GET_COMPANIES_BY_TYPE_ID.value, getCompaniesByTypeIdSaga);
  yield takeLatest(GET_COMPANY.value, getCompanySaga);
  yield takeLatest(GET_COMPANY_TYPES.value, getCompanyTypesSaga);
  yield takeLatest(CREATE_COMPANY.value, createCompanySaga);
  yield takeLatest(UPDATE_COMPANY.value, updateCompanySaga);
  yield takeLatest(DOWNLOAD_COMPANIES.value, downloadCompaniesSaga);
  yield takeLatest(CHANGE_COMPANY_FOR_CONTACT.value, changeCompanyForContactSaga);
  yield takeLatest(CHANGE_COMPANY_FOR_CONTACT_BANNER.value, changeCompanyForContactBannerSaga);
  yield takeEvery(GET_COMPANY_LEVELS.value, getCompanyLevelsSaga);
  yield takeEvery(GET_ALL_COMPANIES.value, getAllCompaniesSaga);
  yield takeLatest(GET_SUP_CALC_INFO.value, getSupCalcInfoSaga);
  yield takeLatest(SAVE_SUP_CALC_SETTINGS.value, saveSupplementalCalcSettingsSaga);
  yield takeEvery(GET_TRACKABLE_PROCESS_INFO.value, getTrackableProcessInfoSaga);
  yield takeEvery(MARK_RUNNING_PROCESSES_AS_STOPPED.value, markRunningProcessesAsStoppedSaga);
  yield takeLatest(GET_COMPANY_LEVEL_BY_ID.value, getCompanyLevelByIdSaga);
  yield takeLatest(GET_COMPANY_TYPE_BY_ID.value, getCompanyTypeByIdSaga);
  yield takeLatest(UPSERT_COMPANY_IDENTIFIER.value, upsertCompanyIdentifierSaga);
  yield takeLatest(DELETE_COMPANY_IDENTIFIER.value, deleteCompanyIdentifierSaga);
  yield takeLatest(GET_SPONSOR_COMPANIES.value, getSponsorCompaniesSaga);
  yield takeLatest(CREATE_COMPANY_REPORTING_EMAIL.value, createCompanyReportingEmailSaga);
}
